import React from 'react';
import { OrganizationForm } from './view';
import { useApolloClient } from '@apollo/react-hooks';
import { useUser } from 'utils/user';
import { nullCheckFormValues } from 'utils/formutils';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useAppOrgQuery, useAppOrgUpdate } from '../../../types/generated';

export function OrganizationEditForm() {
    const client = useApolloClient();
    const user = useUser();

    const { data } = useAppOrgQuery({ variables: { id: user.orgId } });
    const org = data && data.appOrg;

    const [orgUpdate, { loading, error }] = useAppOrgUpdate();

    const onSubmit = (values, form, callback) => {
        values.id = user.orgId;
        orgUpdate({ variables: values })
            .then(appOrgUpdate => {
                user.orgName = appOrgUpdate.data.appOrgUpdate.node.businessName;
                localStorage.setItem('user', JSON.stringify(user));
                client.writeData({ data: { user: user } });
                callback();
            })
            .catch(err => {
                callback(err);
            });
    };

    if (org === undefined) {
        return <CircularProgress />;
    }

    return (
        <OrganizationForm
            organization={nullCheckFormValues(org)}
            loading={loading}
            error={error}
            onSubmit={onSubmit}
        />
    );
}
